'use client';

// Charts.tsx provides the registry id; Chart.tsx reads it so every section
// does not have to thread `chartId` through ChartSectionProps.

import { createContext, useContext } from 'react';

export const ChartAnalyticsIdContext = createContext<string | undefined>(undefined);

export function useChartAnalyticsId(): string | undefined {
  return useContext(ChartAnalyticsIdContext);
}
